import '../../../components/CongratsPage/CongratsPage.css'
import './components.css'

import React from "react";
import DownloadApps from "../../../components/DownloadApps/DownloadsApps";
import {useTranslation} from "react-i18next";

export function BackgroundImage() {
    return <>
        <div className={"congrats-bg-img"}/>
    </>
}

export function CongratsLower() {
    const {t} = useTranslation();
    return <>
        <span>{t("congratsAntennaPlusLower")}</span>
        <button className={"congrats-button secondary"} onClick={()=>{
            window.location.assign(process.env?.REACT_APP_CONGRATS_ANT1GR_LINK ?? "/Account")
        }}>{t("congratsAntennaPlusLowerBtn")}</button>
    </>
}

export function CongratsUpper() {
    const {t} = useTranslation();
    return <>
        <div className={"plus-congrats-container"}>
            <div className={"plus-congrats-top"}>
                <img src={"images/congrats-page/monitor.svg"} alt={"outlined monitor"}/>
                <span>{t("congratsAntennaPlusUpper_TV")}</span>
            </div>
            <div className={"plus-congrats-bot"}>
                <span>{t("congratsAntennaPlusUpper_Mobile")}</span>
                <DownloadApps desktopHidden={false}/>
            </div>
        </div>
    </>
}